/* High As: conversion de los importes en euros a la divisa del visitante.
   VIVE EN SU PROPIO FICHERO A PROPOSITO. Antes iba dentro de high-as.js y
   una excepcion en cualquier funcion anterior de aquel fichero abortaba el
   script entero y se llevaba por delante el conversor. Aqui no depende de
   nada mas: si otra cosa del tema falla, esto sigue funcionando.

   El importe en EUROS vive en data-ha-eur="8.90" y esa es la FUENTE DE VERDAD:
   siempre se recalcula desde ahi, nunca desde el texto ya pintado, asi que se
   puede reaplicar tantas veces como haga falta sin degradarse.
   Si el visitante navega en euros, o si Shopify.currency no esta, o si algo
   falla, no se toca nada: se queda el euro, que es el importe correcto y el
   que cobra el checkout. Nunca se redondea hacia abajo.

   Se REAPLICA con un MutationObserver porque hay contenido que reescribe el
   texto DESPUES de que este script haya corrido: paginas con su propio JS
   (FAQ), apps de traduccion que sustituyen texto en cliente, y secciones
   re-renderizadas. Solo escribe cuando el texto todavia no es el correcto,
   asi que no entra en bucle con quien lo reescriba.

   MODO DIAGNOSTICO: abre cualquier pagina con ?hadebug=1 al final de la
   direccion y sale un recuadro con todo lo que hace falta para saber que
   pasa. Sin ese parametro no se ejecuta nada de eso. */
(function () {
  if (window.haCurrency) return;

  function fx() {
    var c = window.Shopify && window.Shopify.currency;
    if (!c || !c.active || c.active === 'EUR') return null;
    var rate = parseFloat(c.rate);
    if (!isFinite(rate) || rate <= 0) return null;
    return { code: c.active, rate: rate };
  }

  /* Cada divisa se formatea con SU locale, no con el idioma de la pagina: un
     visitante que navega en espanol y paga en dolares tiene que ver "$6.50",
     no "6,50 US dolares". Para las divisas fuera del mapa decide Intl.

     EXCEPCION deliberada: las divisas que en su propio pais se escriben con un
     "$" a secas (CAD, AUD, NZD, SGD, MXN) van con en-US, que las desambigua
     como CA$, A$, NZ$, SGD y MX$. Un "$" pelado se confunde con el dolar
     americano y esa duda sobre el precio cuesta ventas. El yen va igual, con
     en-US, para que salga el simbolo normal y no el de ancho completo. */
  var LOCALES = {
    USD: 'en-US', GBP: 'en-GB', CAD: 'en-US', AUD: 'en-US', NZD: 'en-US',
    CHF: 'de-CH', SEK: 'sv-SE', NOK: 'nb-NO', DKK: 'da-DK', PLN: 'pl-PL',
    CZK: 'cs-CZ', HUF: 'hu-HU', RON: 'ro-RO', JPY: 'en-US', CNY: 'zh-CN',
    BRL: 'pt-BR', MXN: 'en-US', INR: 'en-IN', KRW: 'ko-KR', TRY: 'tr-TR',
    ZAR: 'en-ZA', ILS: 'he-IL', AED: 'ar-AE', SGD: 'en-US', HKD: 'zh-HK',
    THB: 'th-TH'
  };

  var CACHE = {};
  function formatter(code) {
    if (CACHE[code] !== undefined) return CACHE[code];
    var f = null;
    try {
      f = new Intl.NumberFormat(LOCALES[code], { style: 'currency', currency: code });
    } catch (e) {
      try { f = new Intl.NumberFormat(undefined, { style: 'currency', currency: code }); }
      catch (e2) { f = null; }
    }
    CACHE[code] = f;
    return f;
  }

  /* Marcas de direccion (RTL/LTR) que meten locales como he-IL o ar-AE: son
     invisibles pero descolocan el texto cuando va dentro de una frase. */
  var BIDI = new RegExp('[' + String.fromCharCode(0x200e, 0x200f, 0x061c) + ']', 'g');

  /* Redondeo SIEMPRE hacia arriba, nunca hacia abajo: al 0,50 en las divisas
     con decimales y al entero en las que no los tienen (yen, won, forinto). */
  function fmt(value, code) {
    var f = formatter(code);
    if (!f) return null;
    var d = 2;
    try { d = f.resolvedOptions().maximumFractionDigits; } catch (e) {}
    var n = d === 0 ? Math.ceil(value) : Math.ceil(value * 2) / 2;
    return f.format(n).replace(BIDI, '').trim();
  }

  /* Compara por texto plano: comparar innerHTML daria falsos positivos
     porque el navegador lo normaliza, y acabariamos reescribiendo siempre. */
  function setHtml(el, html) {
    var probe = document.createElement('div');
    probe.innerHTML = html;
    if (el.textContent !== probe.textContent) el.innerHTML = html;
  }

  function amounts(scope, c) {
    var els = scope.querySelectorAll('[data-ha-eur]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var eur = parseFloat(el.getAttribute('data-ha-eur'));
      if (!isFinite(eur)) continue;
      var txt = fmt(eur * c.rate, c.code);
      if (txt === null) continue;
      var tpl = el.getAttribute('data-ha-eur-tpl');
      var want = tpl ? tpl.split('__AMT__').join(txt) : txt;
      if (el.textContent !== want) el.textContent = want;
    }
  }

  /* Barra de envio gratis del cajon: el umbral esta en centimos de EURO y
     cart.total_price viene en la divisa de presentacion, asi que hay que
     convertir el umbral antes de comparar. */
  function bar(scope, c) {
    var els = scope.querySelectorAll('[data-ha-free-threshold]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var thr = parseFloat(el.getAttribute('data-ha-free-threshold'));
      var tot = parseFloat(el.getAttribute('data-ha-cart-total'));
      if (!isFinite(thr) || !isFinite(tot) || thr <= 0) continue;
      var thrLocal = Math.ceil(thr * c.rate);
      var missing = thrLocal - tot;
      var pct = Math.round((tot * 100) / thrLocal);
      if (pct > 100) pct = 100;
      if (pct < 0) pct = 0;
      var fill = el.querySelector('.ha-ship__fill');
      if (fill && fill.style.width !== pct + '%') fill.style.width = pct + '%';
      var text = el.querySelector('.ha-ship__text');
      if (!text) continue;
      if (missing > 0) {
        el.classList.remove('ha-ship--done');
        var tpl = el.getAttribute('data-ha-tpl-progress');
        var miss = fmt(missing / 100, c.code);
        if (tpl && miss !== null) setHtml(text, tpl.split('__AMT__').join(miss));
      } else {
        el.classList.add('ha-ship--done');
        var done = el.getAttribute('data-ha-tpl-done');
        if (done) setHtml(text, done);
      }
    }
  }

  /* TEXTO RICO DEL COMERCIANTE (politicas, paginas como la FAQ, banda de
     beneficios). Ahi no sirve data-ha-eur: ese HTML lo escribe el dueno en el
     admin y Shopify le quita al renderizar los atributos que no lleva en su
     lista blanca, asi que los marcadores nunca llegan al DOM. Por eso aqui se
     busca el patron del euro en el propio texto.

     Solo se mira DENTRO de contenedores que emite el TEMA, que si sobreviven:
       .hp-body      sections/main-policy.liquid, cuerpo de las politicas
       .page-content blocks/page-content.liquid, contenido de pagina (FAQ)
       .ha-benefit p banda de beneficios de la portada
     Nunca se barre el documento entero. */
  var RICH = '.hp-body, .page-content, .ha-benefit p';

  /* Dentro de esos contenedores NO se toca lo que ya lleva data-ha-eur (de eso
     se encarga amounts, y asi nunca se convierte dos veces) ni nada que huela
     a precio pintado por Shopify, que ya viene convertido de origen. */
  var SKIP = '[data-ha-eur],[class*=price],.money,price-list,product-price';

  /* Numero pegado a un euro, en cualquiera de las dos formas y con coma o
     punto decimal. Admite el millar separado por espacio, que es como lo
     escribe el frances (1 000 €) y como lo pinta Intl: espacio normal, duro
     (00a0) o fino (202f); y tambien el millar separado por PUNTO, que es como
     lo escriben el espanol y el italiano (1.000 €, 11.707 €). Al exigir el
     simbolo, ni los porcentajes (0,2%) ni los gramajes (350 g/m2) ni los anos
     ni los numeros sueltos entran. */
  var EUR_NUM = '\\d{1,3}(?:[. \\u00a0\\u202f]\\d{3})+(?:,\\d+)?|\\d{1,3}(?:[ \\u00a0\\u202f]\\d{3})+(?:[.,]\\d+)?|\\d+(?:[.,]\\d+)?';
  var EUR_RE = new RegExp('(' + EUR_NUM + ')\\s*€|€\\s*(' + EUR_NUM + ')', 'g');
  var EUR_SEP = new RegExp('[ \\u00a0\\u202f]', 'g');

  /* Punto de MILLAR (no decimal): grupos de exactamente tres cifras, con la
     coma como unico decimal posible. Asi "1.000 €" y "11.707 €" se leen como
     mil y once mil setecientos siete, mientras que el ingles "5.90 €" (dos
     cifras detras del punto) no encaja aqui y se sigue leyendo como decimal. */
  var EUR_DOT = /^\d{1,3}(?:\.\d{3})+(?:,\d+)?$/;

  function skip(node) {
    var el = node.parentNode;
    while (el && el.nodeType === 1) {
      if (el.matches && el.matches(SKIP)) return true;
      el = el.parentNode;
    }
    return false;
  }

  /* Se reescribe el NODO DE TEXTO, nunca el textContent del elemento: asi las
     negritas, los enlaces y los iconos de dentro del parrafo quedan intactos.
     El original se guarda en el propio nodo para poder recalcular siempre.
     Un texto ya convertido no lleva el simbolo del euro, asi que si pierde el
     original tampoco puede tomarse por uno nuevo: no se degrada nunca. */
  function convert(node, c) {
    var src = node.haEurSrc;
    if (src === undefined) {
      src = node.nodeValue;
      EUR_RE.lastIndex = 0;
      if (!EUR_RE.test(src)) return;
      if (skip(node)) return;
      node.haEurSrc = src;
    }
    EUR_RE.lastIndex = 0;
    var want = src.replace(EUR_RE, function (m, a, b) {
      var raw = String(a === undefined ? b : a).replace(EUR_SEP, '');
      if (EUR_DOT.test(raw)) raw = raw.split('.').join('');
      raw = raw.replace(',', '.');
      var n = parseFloat(raw);
      var t = isFinite(n) ? fmt(n * c.rate, c.code) : null;
      return t === null ? m : t;
    });
    if (node.nodeValue !== want) node.nodeValue = want;
  }

  /* Tres senales independientes para saber si estamos en una politica. La de
     la URL es la que no falla nunca, las otras dos son por si Shopify cambia
     las rutas. */
  function isPolicy() {
    var b = document.body;
    if (b && (b.className || '').indexOf('ha-pt-policy') > -1) return true;
    var mc = document.getElementById('MainContent');
    var t = mc ? (mc.getAttribute('data-template') || '') : '';
    if (t.indexOf('policy') === 0) return true;
    return ((window.location && window.location.pathname) || '').indexOf('/policies/') > -1;
  }

  function mainBox() {
    return document.getElementById('MainContent') ||
      document.querySelector('.content-for-layout') ||
      document.querySelector('main');
  }

  /* Contenedores sobre los que actuar. En una politica se anade SIEMPRE el
     contenido principal: es la unica pagina donde el marcado del tema nos ha
     fallado, no lleva ningun precio de Shopify, y convertir dos veces el mismo
     nodo no hace nada porque convert() recalcula desde el original. */
  function boxes(scope) {
    var found = scope.querySelectorAll(RICH);
    var list = [];
    for (var i = 0; i < found.length; i++) { list.push(found[i]); }
    if (isPolicy()) {
      var m = mainBox();
      if (m && list.indexOf(m) === -1) list.push(m);
    }
    return list;
  }

  function rich(scope, c) {
    if (!document.createTreeWalker) return;
    var list = boxes(scope);
    for (var i = 0; i < list.length; i++) {
      var walker = document.createTreeWalker(list[i], NodeFilter.SHOW_TEXT, null, false);
      var nodes = [];
      var n;
      while ((n = walker.nextNode()) !== null) { nodes.push(n); }
      for (var j = 0; j < nodes.length; j++) { convert(nodes[j], c); }
    }
  }

  /* Cada pasada va en su propio try. Antes compartian uno solo, asi que una
     excepcion en la primera dejaba las demas sin ejecutar y en silencio.
     Si algo falla se queda el euro, que es el importe correcto de partida.
     Los errores se guardan para poder ensenarlos en el modo diagnostico. */
  var ERRORS = [];
  function attempt(fn, scope, c) {
    try {
      fn(scope, c);
    } catch (e) {
      if (ERRORS.length < 8) {
        ERRORS.push((fn.name || 'paso') + ': ' + ((e && e.message) ? e.message : String(e)));
      }
    }
  }

  function notes(scope) {
    var els = scope.querySelectorAll('[data-ha-fx-note]');
    for (var i = 0; i < els.length; i++) { if (els[i].hidden) els[i].hidden = false; }
  }

  function apply(root) {
    var c = null;
    try { c = fx(); } catch (e) { return; }
    if (!c) return;
    var scope = root && root.querySelectorAll ? root : document;
    attempt(amounts, scope, c);
    attempt(bar, scope, c);
    attempt(rich, scope, c);
    attempt(notes, scope, c);
  }

  /* Reaplicacion agrupada. El tope corta cualquier ping-pong con un tercero;
     los eventos de usuario lo reinician, asi que navegar nunca se queda sin. */
  var timer = null;
  var passes = 0;
  function schedule() {
    if (timer !== null || passes > 80) return;
    timer = setTimeout(function () { timer = null; passes++; apply(); }, 60);
  }
  function scheduleUser() { passes = 0; schedule(); }

  function watch() {
    if (!window.MutationObserver || !document.body) return;
    try {
      new MutationObserver(schedule).observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
      });
    } catch (e) {}
  }

  function start() {
    apply();
    /* El recuadro se pinta ANTES de cualquier salida temprana, para que se vea
       tambien cuando la divisa es el euro o el conversor no actua. */
    debugPanel();
    if (debugOn()) {
      setTimeout(debugPanel, 900);
      setTimeout(debugPanel, 2500);
    }
    /* En euros no se engancha nada: coste cero para el mercado de España. */
    if (!fx()) return;
    watch();
    document.addEventListener('click', scheduleUser, true);
  }

  /* Diagnostico de un vistazo: escribe haCurrency.state() en la consola del
     navegador y dice si la divisa esta activa, a que tipo, cuantos importes
     marcados hay en la pagina y cuantos contenedores de texto rico. */
  function state() {
    var c = window.Shopify && window.Shopify.currency;
    var mc = document.getElementById('MainContent');
    return {
      active: c ? c.active : null,
      rate: c ? c.rate : null,
      converting: fx() !== null,
      path: (window.location && window.location.pathname) || null,
      bodyClass: document.body ? document.body.className : null,
      dataTemplate: mc ? mc.getAttribute('data-template') : null,
      isPolicy: isPolicy(),
      nodes: document.querySelectorAll('[data-ha-eur]').length,
      hpBody: document.querySelectorAll('.hp-body').length,
      pageContent: document.querySelectorAll('.page-content').length,
      mainFound: mainBox() !== null,
      boxesUsed: boxes(document).length,
      euroLeft: (document.body ? (document.body.textContent.match(/€/g) || []).length : 0)
    };
  }

  /* MODO DIAGNOSTICO VISIBLE.
     Se activa SOLO si la URL lleva ?hadebug=1. Sin ese parametro no se ejecuta
     ni una linea de aqui, asi que el coste para un cliente normal es cero.
     Se pinta SIEMPRE que el parametro este puesto, aunque la divisa sea el
     euro y aunque el conversor decida no actuar: es una herramienta para ver
     que pasa cuando algo va mal, no puede depender de que vaya bien. */
  function debugOn() {
    try {
      return (((window.location && window.location.search) || '').indexOf('hadebug=1') > -1);
    } catch (e) {
      return false;
    }
  }

  /* Importes en euros que quedan SIN convertir en toda la pagina, con la
     etiqueta y las clases del elemento que los contiene. */
  function leftovers(limit) {
    var out = [];
    var total = 0;
    if (!document.body || !document.createTreeWalker) return { list: out, total: 0 };
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
    var n;
    while ((n = w.nextNode()) !== null) {
      var v = n.nodeValue || '';
      var hits = v.match(/€/g);
      if (!hits) continue;
      total += hits.length;
      if (out.length < limit) {
        var p = n.parentNode;
        var tag = (p && p.tagName) ? p.tagName.toLowerCase() : '?';
        var cls = (p && p.getAttribute) ? (p.getAttribute('class') || '') : '';
        out.push(tag + (cls ? '.' + cls.replace(/\s+/g, '.') : '') +
          '\n      texto: ' + v.replace(/\s+/g, ' ').slice(0, 90));
      }
    }
    return { list: out, total: total };
  }

  function report() {
    var c = window.Shopify && window.Shopify.currency;
    var mc = document.getElementById('MainContent');
    var left = leftovers(3);
    var L = [];
    L.push('HIGH AS - DIAGNOSTICO DE DIVISA');
    L.push('===============================');
    L.push('script cargado    : SI');
    L.push('Shopify.currency  : ' + (c ? ('active=' + c.active + '  rate=' + c.rate) : 'NO EXISTE'));
    L.push('convirtiendo      : ' + (fx() !== null ? 'SI' : 'NO'));
    L.push('ruta              : ' + ((window.location && window.location.pathname) || '?'));
    L.push('clase del body    : ' + (document.body ? (document.body.className || '(vacia)') : '?'));
    L.push('data-template     : ' + (mc ? (mc.getAttribute('data-template') || '(vacio)') : 'sin #MainContent'));
    L.push('es politica       : ' + (isPolicy() ? 'SI' : 'NO'));
    L.push('');
    L.push('.hp-body          : ' + document.querySelectorAll('.hp-body').length);
    L.push('.page-content     : ' + document.querySelectorAll('.page-content').length);
    L.push('#MainContent      : ' + (mainBox() ? 'encontrado' : 'NO encontrado'));
    L.push('contenedores usados: ' + boxes(document).length);
    L.push('nodos data-ha-eur : ' + document.querySelectorAll('[data-ha-eur]').length);
    L.push('');
    L.push('euros SIN convertir: ' + left.total);
    if (left.list.length) {
      for (var i = 0; i < left.list.length; i++) {
        L.push('  ' + (i + 1) + ') ' + left.list[i]);
      }
    } else {
      L.push('  (ninguno)');
    }
    L.push('');
    if (ERRORS.length) {
      L.push('ERRORES:');
      for (var j = 0; j < ERRORS.length; j++) { L.push('  - ' + ERRORS[j]); }
    } else {
      L.push('errores           : ninguno');
    }
    L.push('');
    L.push('Quita ?hadebug=1 de la direccion para ocultar este recuadro.');
    return L.join('\n');
  }

  function paint() {
    if (!debugOn() || !document.body) return;
    var box = document.getElementById('ha-debug-box');
    if (!box) {
      box = document.createElement('div');
      box.id = 'ha-debug-box';
      box.setAttribute('style', [
        'position:fixed',
        'top:10px',
        'right:10px',
        'z-index:2147483647',
        'width:440px',
        'max-width:92vw',
        'max-height:82vh',
        'overflow:auto',
        'background:#0b1020',
        'color:#ffffff',
        'border:2px solid #f2900f',
        'border-radius:10px',
        'padding:12px 14px',
        'font-family:ui-monospace,SFMono-Regular,Menlo,Consolas,monospace',
        'font-size:12px',
        'line-height:1.5',
        'white-space:pre-wrap',
        'word-break:break-word',
        'text-align:left',
        'box-shadow:0 10px 40px rgba(0,0,0,0.55)'
      ].join(';'));
      document.body.appendChild(box);
    }
    box.textContent = report();
  }

  /* Todo el modo diagnostico va aislado: si algo de aqui fallara, no puede
     romper la pagina ni impedir la conversion. */
  function debugPanel() {
    try { paint(); } catch (e) {}
  }

  window.haCurrency = { apply: apply, state: state, debug: debugPanel };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', function (e) { passes = 0; apply(e.target); });
  window.addEventListener('pageshow', function () { passes = 0; apply(); });
})();